/*
 * @Author: 姚林刚
 * @Date: 2023-05-05 15:34:45
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-05-05 15:49:48
 * @Description: 过滤器
 */
/** 数字千位分隔符 */
export function numberSeparator(number = null) {
  let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
  if (number == null) {
    return "--";
  }
  if (!number) return 0;
  else return number.toString().replace(regex, ",");
}
/**
 * 10000 => "10,000.00"
 * @param {number} num
 */
export function toThousandFloatFilter(num) {
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
/** 数字千位分隔符 超过1万保留小数点后1位 */
export function numberSeparatorTofiexed(number = 0) {
  let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
  if (!number) {
    return 0;
  } else {
    let num = number;
    if (num >= 10000) {
      num = num / 10000;
      num = num.toFixed(1);
      return num.toString().replace(regex, ".");
    } else {
      return num.toString().replace(regex, ",");
    }
  }
}
/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}
